<template>
    <div>
        <van-popup v-model="show" position="bottom">
            <van-datetime-picker
                v-model="currentDate"
                type="date"
                title="选择年月日"
                :min-date="minDate"
                :max-date="maxDate"
                @cancel="showPopup(false)"
                @confirm="confirmTimeBoxFun"
            />
        </van-popup>
    </div>
</template>

<script>
import Vue from 'vue';
import { Popup } from 'vant';
import { DatetimePicker } from 'vant';
Vue.use(DatetimePicker);
Vue.use(Popup);
var that;
var date = new Date();
var yyy = date.getFullYear()
export default {
    data() {
        return {
            show: false,
            minDate: new Date(yyy-10,0,1),
            maxDate: new Date(yyy+10,11,31),
            currentDate: date,
        };
    },
    mounted(){
        that = this;
    },
    methods: {
        showPopup(val) {
            that.show = val;
        },
        // 时间弹框 点击确认
        confirmTimeBoxFun(val){
            that.show = false;
            that.$emit('timeConfirm',val)
        }

    },
}
</script>

<style scoped>

</style>